import { useEffect, useState } from 'react';
import { getPriestToCartAPI, deletePriestFromCartAPI,refundpreistfromcartapi } from '../Apiservices/Auth/cart/Addtocart_api';
import { useDispatch,useSelector } from 'react-redux';
import { addServiceToCart,removePriestByCartId } from '../store/cartbodydataslice';

export const usePriestCart = () => {
  const [priestCartData, setPriestCartData] = useState([]);
  const [priestCartLoading, setPriestCartLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const dispatch = useDispatch();
  // const eventDataMap = useSelector(selectAllEventDetails);
  useEffect(() => {
    const fetchPriestCart = async () => {
      setPriestCartLoading(true);
      try {
        const response = await getPriestToCartAPI();   

        const result = response?.result || [];
        console.log("resultpriest",response.result)
        setPriestCartData(result);        
        result.forEach((eventItem) => {          
          const eveId = eventItem.event_id;  ;
          const eventName = eventItem.event_title;
          eventItem.priestItems.forEach((priestItem) => {  
            const is_checked_out = priestItem.is_checked_out     
               const balance_to_be_paid = priestItem.balance_to_be_paid;
          const paid_amount = priestItem.paid_amount;     
          const is_edit_allowed = priestItem.is_edit_allowed;
            const provider = priestItem.priest;
            const pricing = priestItem.pricing;
            const cart_id = priestItem.id 
            dispatch(
              addServiceToCart({
                eveId,
                eventname: eventName,
                type: 'preistData',    
                item: {
                is_checked_out:is_checked_out,
                is_edit_allowed:is_edit_allowed,
                paid_amount:paid_amount,
                balance_to_be_paid:balance_to_be_paid,

                is_cancel_in_progress:priestItem.is_cancel_in_progress,
                is_canceled:priestItem.is_canceled,
                refund_complete:priestItem.refund_complete,
                refund_in_pending:priestItem.refund_in_pending,
                refunded_amount:priestItem.refunded_amount,

                  provider_id: provider.id,
                  providername: provider.name,
                  price: pricing.price,
                  discountPrice: pricing.discountPrice,
                  validUpto: pricing.discountValidUpto,
                  service_id: priestItem.service.id,
                  cart_id: cart_id,
                  mobileNumber: provider.mobileNumber,                  
                },
              })
            );
          });
        });

        console.log('Fetched priest cart and dispatched to Redux:', result);
      } catch (err) {
        console.error('Error loading priest cart:', err);
        setPriestCartData([]);
      }
      setPriestCartLoading(false);
    };

    fetchPriestCart();
  }, [refreshTrigger]);

  const refreshPriestCart = () => setRefreshTrigger((prev) => prev + 1);

  const removePriestCartItem = async (cartId,eventId) => {
    console.log('called here1')
    try {
      await deletePriestFromCartAPI(cartId);
      refreshPriestCart();
      dispatch(removePriestByCartId({eventId,cartId}))
    } catch (err) {
      console.error('Error removing priest item:', err);
    }
  };

const refundpreistfromcart = async (event_id, provider_id) => {
  try {
    const response = await refundpreistfromcartapi(event_id, provider_id);
    return response; 
  } catch (error) {
    console.error("Refund Priest from cart error:", error.message);
    throw error; 
  }
};

  return {
    priestCartData,
    priestCartLoading,
    refreshPriestCart,
    removePriestCartItem,
    refundpreistfromcart,
  };
};
